<template>
  <formMessage isShowSubmit="true"></formMessage>
</template>
<script>
  import formMessage from '../components/form-message'
  import {mapMutations} from 'vuex'
  export default {
    components: {
      formMessage
    },
    data () {
      return {}
    },
    methods: {
      ...mapMutations({
        set_leaveType: 'set_leaveType',
        setVisitorInfo: 'setVisitorInfo'
      })
    },
    created () {
      let param = this.$route.query;
      if (param.isSource == 1) {

      } else {
        this.set_leaveType(param.leaveType)
        delete param.leaveType
        this.setVisitorInfo(param)
      }
    }
  }
</script>
